import styles from './ArticleTakeaways.module.scss';

type ArticleTakeawaysProps = {
  takeaways: string[];
};

const ArticleTakeaways = ({
  takeaways,
}: ArticleTakeawaysProps): JSX.Element | null => {
  if (!takeaways.length) {
    return null;
  }

  return (
    <section className={styles.root} aria-labelledby="article-takeaways">
      <h2 id="article-takeaways" className={styles.title}>
        Key takeaways
      </h2>
      <ul className={styles.list}>
        {takeaways.map((takeaway, index) => (
          <li key={`${index}-${takeaway}`} className={styles.item}>
            {takeaway}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ArticleTakeaways;
